var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"bg"}},[_c('Header'),_c('particles-bg',{attrs:{"id":"moving-bg","type":"custom","canvas":{
        background: 'linear-gradient( #6666FF, #d1c4e9)',
      },"width":40,"height":40,"config":_vm.config,"bg":true}}),_c('router-view'),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }